import i18next from 'i18next';
import lang from './i18n.generated';
import { locale_en } from './locales/en/locale_en';
import { locale_es } from './locales/es/locale_es';
import { locale_fr } from './locales/fr/locale_fr';
import { locale_pt } from './locales/pt/locale_pt';
import { locale_ru } from './locales/ru/locale_ru';
export enum Languages {
  English = 'en',
  Spanish = 'es',
  Portuguese = 'pt',
  Russian = 'ru',
  French = 'fr',
}
i18next.init({
  lng: 'en',
  // we init with resources
  resources: {
    en: {
      translations: locale_en,
    },
    es: {
      translations: locale_es,
    },
    pt: {
      translations: locale_pt,
    },
    fr: {
      translations: locale_fr,
    },
    ru: {
      translations: locale_ru,
    },
  },
  fallbackLng: lang.source,
  debug: false,

  // have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // we use content as keys
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
  },
});

export default i18next;
